import { FC } from 'react'
import { Navigate, Outlet, redirect, type LoaderFunctionArgs } from 'react-router-dom'
import { useUser } from '@clerk/clerk-react'
import './pledge.css'

// COMPONENTS
import { Column } from '@components/templates/column'

// ROUTES
import { PledgeDefaultRoute } from './default'
import { PMRoute } from './pm'
import PledgeReviewRoute from './review'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { getGroupStatus } from '@utils/temp-helpers'
import { isNonEmptyString } from '@utils/type-checkers'
import { useGroupLoaderData, usePledgeOutletContext } from '../'


const Component: FC<{}> = () => {
    const { user: clerkUser, isSignedIn } = useUser()
    const context = usePledgeOutletContext()
    const group = useGroupLoaderData()
    const { groupStatus } = getGroupStatus(group)

    const { organizer } = group
    const isOrganizer = isSignedIn ? organizer?.id === clerkUser.id : false

    const hasPledge = !!group.pledges?.find(({ user }) => (user?.id === clerkUser?.id))

    if (isOrganizer || hasPledge || groupStatus !== 'active') return <Navigate to={`/group/${group.id}`} replace={true} />
    else return (<>
        <Column.Content className="group-pledge-screen">
            <Outlet context={context} />
        </Column.Content>
    </>)
}

// Joining groups has been removed (FNT-744). Block the join flow entirely.
const loader = ({ params }: LoaderFunctionArgs) =>
    redirect(isNonEmptyString(params.groupId) ? `/group/${params.groupId}` : '/account')

const PledgeRoute: RouteObject = {
    path: "pledge",
    Component,
    loader,
    children: [
        PledgeDefaultRoute,
        PMRoute,
        PledgeReviewRoute
    ],
}

export default PledgeRoute
